export default __webpack_public_path__ + "static/media/press-13.24809cde.jpg";